import { render, staticRenderFns } from "./SendMailBasic.vue?vue&type=template&id=72b2936c&"
import script from "./SendMailBasic.vue?vue&type=script&lang=js&"
export * from "./SendMailBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports